'use client';
import { memo, useState } from 'react';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';

import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Popover from '@mui/material/Popover';
import { BiDotsVerticalRounded } from '@react-icons/all-files/bi/BiDotsVerticalRounded';

import { Checkbox, InputText } from '../../../input';
import { useTableContext } from '../with-provider';

interface IColumnFilter {
  id: string;
}

export const ColumnFilter = memo<IColumnFilter>(function ColumnFilter({ id }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const _id = open ? 'display-options-popover' : undefined;
  const [search, setSearch] = useState('');
  const { table } = useTableContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearch('');
  };

  if (!table) return null;

  return (
    <>
      <IconButton
        aria-describedby={_id}
        onClick={handleClick}
        id={id}
        sx={{
          width: 32,
          height: 32,
          borderRadius: '4px',
          border: '1px solid #E3E3E3',
        }}
      >
        <BiDotsVerticalRounded size={16} />
      </IconButton>

      <Popover
        id={_id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box p={1.5}>
          <Typography gutterBottom fontWeight={600}>
            Opções de exibição
          </Typography>
          <InputText
            placeholder="Pesquise"
            size="small"
            fullWidth
            onChange={(e) => setSearch(e.target.value)}
            sx={{ height: 35 }}
          />
        </Box>

        <List
          sx={{ width: 250, maxWidth: 250, maxHeight: 400, overflowY: 'auto' }}
        >
          {table
            ?.getAllLeafColumns()
            ?.filter((item: any) => item.id !== 'select-col')
            ?.filter((item: any) => item.getCanHide())
            ?.filter((column: any) => {
              if (typeof column?.columnDef?.header !== 'string') return false;

              const label = (
                (column?.columnDef?.header as string) || ''
              )?.toLowerCase();

              return label?.includes(search);
            })
            .map((column: any) => (
              <ListItemButton
                dense
                key={column.id}
                onClick={() => column.toggleVisibility()}
              >
                <Checkbox
                  size="small"
                  checked={column.getIsVisible()}
                  id={column.columnDef.header as string}
                  sx={{ height: 28, width: 28, mr: 1 }}
                />

                <ListItemText>{column.columnDef.header as string}</ListItemText>
              </ListItemButton>
            ))}
        </List>
      </Popover>
    </>
  );
});
